<template lang="pug">
.form-multi-file
  .register-row
    .register-group
      .register-key
        .left-side.d-flex
          span.key-name 添付PDFファイル
          span.comment ※PDFファイルを1ファイルだけ登録可能です
        .right-side
          HelpIcon(popoverId="temp-files-help" :title="'選択可能なファイルについて'")
            template(#text)
              span 選択可能なファイルは、pdfのみです。
              span 送信可能なファイルサイズは50MBまでです。
              span ファイルサイズが大きいと送信に時間がかかりますので、なるべく小さいサイズにしてください。
      .register-value
        .d-flex.flex-column
          MultiFileSelecter(
            ref="fileSelecter"
            :mimetypes="['application/pdf']"
            width="450px"
            height="74px"
            :limit="_registerImageFilesLimit"
            :showPreview="true"
            :enablePreviewStatus="_enablePreviewStatus"
            @input="inputFiles"
            @preview="onTempFilePreview"
          )
          input(name="tempfiles-multiple-register-errors" data-vv-as="添付ファイル" style="display: none")
          .error-messages.text-break(v-for="error in errors.collect('tempfiles-multiple-register-errors')" :style="{ 'maxWidth': '500px' }")
            label.error-message {{ error }}
            br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";

@Component({
  components: {
    HelpIcon,
    MultiFileSelecter
  }
})
export default class FormMultiFile extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop()
  registerImageFilesLimit!: number;

  @Prop()
  enablePreviewStatus!: boolean;

  get _registerImageFilesLimit(): number {
    return this.registerImageFilesLimit;
  }

  get _enablePreviewStatus(): boolean {
    return this.enablePreviewStatus;
  }

  public inputFiles(files: Array<File>): void {
    this.$emit("inputFiles", files);
    return;
  }

  public onTempFilePreview(): void {
    this.$emit("onTempFilePreview");
    return;
  }
}
</script>
